import baseApi from './baseApi';

export interface MoodleSsoLoginResponse {
  loginUrl: string;
}

const moodleApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    moodleSsoLogin: build.mutation<MoodleSsoLoginResponse, void>({
      query: () => ({
        url: '/moodle/sso-login',
        method: 'POST',
      }),
    }),
  }),
});

export const { useMoodleSsoLoginMutation } = moodleApi;

export default moodleApi;
